export interface ManhwaSite {
  id: string;
  name: string;
  desc: string;
  tags: string[];
  categoryId: string;
  rating: number;
  viewers: string;
  feature: string;
}

export interface Category {
  id: string;
  name: string;
  tagline: string;
  badge: string;
  count: number;
  image: string;
  sites: ManhwaSite[];
}

export interface HotSite {
  id: string;
  rank: number;
  name: string;
  tagline: string;
  desc: string;
  tags: string[];
  rating: number;
  viewers: string;
  update: string;
  hot: boolean;
}

export interface ReleasePage {
  id: string;
  site: string;
  title: string;
  tag: string;
  today: string;
  badge: string;
}

export interface GuideStep {
  id: string;
  num: string;
  title: string;
  desc: string;
}

export interface FaqItem {
  id: string;
  q: string;
  a: string;
}

export const siteCategories: Category[] = [
  {
    id: "action",
    name: "动作热血",
    tagline: "打斗燃、剧情爽，高能不断的硬核连载",
    badge: "本周最热",
    count: 46,
    image:
      "https://readdy.ai/api/search-image?query=Dynamic%20Korean%20webtoon%20action%20manhwa%20art%20of%20a%20young%20hero%20throwing%20a%20powerful%20punch%20with%20speed%20lines%20and%20sparks%2C%20bold%20coral%20red%20and%20deep%20warm%20background%2C%20high%20energy%2C%20comic%20style%20illustration&width=800&height=600&seq=cat-action&orientation=landscape",
    sites: [
      {
        id: "ac01",
        name: "热血漫库",
        desc: "专注动作与格斗题材，更新速度快，追更体验流畅。",
        tags: ["格斗", "热血", "高清"],
        categoryId: "action",
        rating: 4.9,
        viewers: "286万",
        feature: "每日零点更新",
      },
      {
        id: "ac02",
        name: "强拳韩漫",
        desc: "硬核打斗剧情合集，附带角色设定与战力盘点专题。",
        tags: ["打斗", "连载", "专题"],
        categoryId: "action",
        rating: 4.8,
        viewers: "173万",
        feature: "战力盘点专题",
      },
      {
        id: "ac03",
        name: "燃站",
        desc: "动作番每周定时更新，剧集列表清晰，收藏即追更。",
        tags: ["动作", "周更", "收藏"],
        categoryId: "action",
        rating: 4.7,
        viewers: "129万",
        feature: "周更稳定",
      },
    ],
  },
  {
    id: "romance",
    name: "恋爱校园",
    tagline: "心动日常与青春悸动，甜甜的连载都在这里",
    badge: "女生最爱",
    count: 38,
    image:
      "https://readdy.ai/api/search-image?query=Soft%20Korean%20webtoon%20romance%20manhwa%20illustration%20of%20a%20school%20couple%20under%20cherry%20blossoms%2C%20warm%20peach%20and%20cream%20tones%2C%20tender%20young%20love%20atmosphere%2C%20gentle%20comic%20style&width=800&height=600&seq=cat-romance&orientation=landscape",
    sites: [
      {
        id: "ro01",
        name: "心动条漫",
        desc: "校园恋爱与青梅竹马题材，画风细腻，糖分十足。",
        tags: ["校园", "甜宠", "细腻"],
        categoryId: "romance",
        rating: 4.9,
        viewers: "312万",
        feature: "人气恋爱榜",
      },
      {
        id: "ro02",
        name: "少女漫社",
        desc: "女生向恋爱连载集合，含女频榜单与完结推荐。",
        tags: ["女生向", "完结", "榜单"],
        categoryId: "romance",
        rating: 4.8,
        viewers: "198万",
        feature: "女频精选",
      },
      {
        id: "ro03",
        name: "初恋漫屋",
        desc: "青春悸动与成长故事，更新稳定，支持追更提醒。",
        tags: ["青春", "成长", "提醒"],
        categoryId: "romance",
        rating: 4.6,
        viewers: "95万",
        feature: "追更提醒",
      },
    ],
  },
  {
    id: "fantasy",
    name: "奇幻异世界",
    tagline: "穿越冒险、魔法世界，脑洞大开的异世界之旅",
    badge: "热门题材",
    count: 52,
    image:
      "https://readdy.ai/api/search-image?query=Epic%20Korean%20webtoon%20fantasy%20isekai%20manhwa%20illustration%20of%20a%20sword%20and%20magic%20adventurer%20in%20a%20glowing%20world%2C%20vibrant%20teal%20and%20amber%20magical%20glow%2C%20immersive%20comic%20art&width=800&height=600&seq=cat-fantasy&orientation=landscape",
    sites: [
      {
        id: "fa01",
        name: "异界漫游",
        desc: "穿越与魔法题材大全，世界观设定详尽，更新迅速。",
        tags: ["穿越", "魔法", "世界观"],
        categoryId: "fantasy",
        rating: 4.9,
        viewers: "268万",
        feature: "世界观设定集",
      },
      {
        id: "fa02",
        name: "次元客栈",
        desc: "异世界冒险故事合集，含新作连载与经典重制。",
        tags: ["异世界", "冒险", "新作"],
        categoryId: "fantasy",
        rating: 4.8,
        viewers: "152万",
        feature: "新作抢先看",
      },
      {
        id: "fa03",
        name: "魔法书页",
        desc: "奇幻题材精选，画风华丽，追更入口稳定可靠。",
        tags: ["奇幻", "华丽", "稳定"],
        categoryId: "fantasy",
        rating: 4.7,
        viewers: "118万",
        feature: "高清画质",
      },
    ],
  },
  {
    id: "thriller",
    name: "悬疑惊悚",
    tagline: "烧脑反转、紧张氛围，让人欲罢不能的谜局",
    badge: "口碑之选",
    count: 29,
    image:
      "https://readdy.ai/api/search-image?query=Mysterious%20noir%20Korean%20webtoon%20thriller%20manhwa%20illustration%20of%20a%20silhouette%20in%20a%20dark%20moody%20alley%20with%20fog%20and%20teal%20underlighting%2C%20suspenseful%20tense%20atmosphere%2C%20cinematic%20comic%20art&width=800&height=600&seq=cat-thriller&orientation=landscape",
    sites: [
      {
        id: "th01",
        name: "迷局档案",
        desc: "悬疑推理与反转剧情合集，附案情梳理与伏笔解析。",
        tags: ["推理", "反转", "解析"],
        categoryId: "thriller",
        rating: 4.9,
        viewers: "142万",
        feature: "伏笔解析专栏",
      },
      {
        id: "th02",
        name: "惊悚夜谈",
        desc: "惊悚氛围与心理博弈，更新及时，深夜阅读首选。",
        tags: ["惊悚", "心理", "氛围"],
        categoryId: "thriller",
        rating: 4.7,
        viewers: "88万",
        feature: "深夜更新",
      },
      {
        id: "th03",
        name: "黑雾漫刊",
        desc: "都市谜团与犯罪题材，剧情紧凑，追更入口稳定。",
        tags: ["犯罪", "紧凑", "稳定"],
        categoryId: "thriller",
        rating: 4.6,
        viewers: "67万",
        feature: "紧凑剧情",
      },
    ],
  },
  {
    id: "comedy",
    name: "搞笑日常",
    tagline: "轻松解压、沙雕爆笑，日常里的快乐源泉",
    badge: "解压必看",
    count: 34,
    image:
      "https://readdy.ai/api/search-image?query=Cheerful%20Korean%20webtoon%20comedy%20slice%20of%20life%20manhwa%20illustration%20of%20happy%20young%20friends%20laughing%20in%20a%20bright%20cafe%2C%20warm%20yellow%20and%20cream%20palette%2C%20playful%20lighthearted%20comic%20style&width=800&height=600&seq=cat-comedy&orientation=landscape",
    sites: [
      {
        id: "co01",
        name: "沙雕漫画社",
        desc: "搞笑日常与无厘头剧情合集，快乐源泉不断更。",
        tags: ["搞笑", "日常", "解压"],
        categoryId: "comedy",
        rating: 4.8,
        viewers: "176万",
        feature: "日更不断",
      },
      {
        id: "co02",
        name: "开心漫铺",
        desc: "轻松向轻喜剧连载，画风可爱，追更无压力。",
        tags: ["轻喜剧", "可爱", "轻松"],
        categoryId: "comedy",
        rating: 4.7,
        viewers: "120万",
        feature: "轻喜剧榜",
      },
      {
        id: "co03",
        name: "元气日常",
        desc: "校园与职场的搞笑日常，沙雕表情包出圈不断。",
        tags: ["校园", "职场", "出圈"],
        categoryId: "comedy",
        rating: 4.6,
        viewers: "93万",
        feature: "表情包出圈",
      },
    ],
  },
  {
    id: "urban",
    name: "都市职场",
    tagline: "社会写实、权谋商战，成人向的都市故事",
    badge: "成人向",
    count: 31,
    image:
      "https://readdy.ai/api/search-image?query=Modern%20Korean%20webtoon%20urban%20office%20manhwa%20illustration%20of%20a%20confident%20young%20professional%20in%20front%20of%20a%20city%20skyline%20at%20sunset%2C%20amber%20and%20warm%20coral%20tones%2C%20sophisticated%20comic%20art&width=800&height=600&seq=cat-urban&orientation=landscape",
    sites: [
      {
        id: "ur01",
        name: "都市物语",
        desc: "都市权谋与商战剧情，人物丰满，更新稳中有快。",
        tags: ["权谋", "商战", "丰满"],
        categoryId: "urban",
        rating: 4.8,
        viewers: "164万",
        feature: "商战专题",
      },
      {
        id: "ur02",
        name: "职场风云",
        desc: "职场成长与人性博弈，写实剧情引起广泛共鸣。",
        tags: ["职场", "写实", "共鸣"],
        categoryId: "urban",
        rating: 4.7,
        viewers: "101万",
        feature: "写实共鸣",
      },
      {
        id: "ur03",
        name: "成人漫评社",
        desc: "成人向都市连载合集，附剧情分析与角色解读。",
        tags: ["成人向", "解读", "连载"],
        categoryId: "urban",
        rating: 4.6,
        viewers: "79万",
        feature: "深度解读",
      },
    ],
  },
];

export const hotSites: HotSite[] = [
  {
    id: "h01",
    rank: 1,
    name: "韩漫屋",
    tagline: "全题材韩漫聚合首选",
    desc: "覆盖动作、恋爱、奇幻等全题材，入口稳定、更新及时，是追更韩漫的一站式选择。",
    tags: ["全题材", "稳定", "更新快"],
    rating: 4.9,
    viewers: "520万",
    update: "今日 09:20",
    hot: true,
  },
  {
    id: "h02",
    rank: 2,
    name: "条漫星球",
    tagline: "人气连载高清阅读",
    desc: "主打人气连载与高清画质，阅读页清爽无干扰，支持一键收藏追更。",
    tags: ["人气", "高清", "清爽"],
    rating: 4.8,
    viewers: "430万",
    update: "今日 11:05",
    hot: true,
  },
  {
    id: "h03",
    rank: 3,
    name: "追更社",
    tagline: "更新提醒与榜单速报",
    desc: "专注更新提醒与热门榜单，追更记录云端同步，不错过任何一期新作。",
    tags: ["提醒", "榜单", "同步"],
    rating: 4.8,
    viewers: "380万",
    update: "今日 08:40",
    hot: false,
  },
  {
    id: "h04",
    rank: 4,
    name: "漫小馆",
    tagline: "新作抢先与新番盘点",
    desc: "新作首发与每季新番盘点，题材分类细致，找到想看的韩漫更快。",
    tags: ["新作", "盘点", "分类"],
    rating: 4.7,
    viewers: "290万",
    update: "昨日 22:15",
    hot: false,
  },
  {
    id: "h05",
    rank: 5,
    name: "韩漫图鉴",
    tagline: "专题整理与深度阅读",
    desc: "按题材与画风做专题整理，含完结补番指南，阅读体验完整舒适。",
    tags: ["专题", "补番", "舒适"],
    rating: 4.7,
    viewers: "230万",
    update: "昨日 20:30",
    hot: false,
  },
  {
    id: "h06",
    rank: 6,
    name: "追更雷达",
    tagline: "多站更新聚合提醒",
    desc: "聚合多站点更新动态，一次查看全部最新发布，追更更省心。",
    tags: ["聚合", "动态", "省心"],
    rating: 4.6,
    viewers: "175万",
    update: "今日 07:55",
    hot: false,
  },
];

export const releasePages: ReleasePage[] = [
  {
    id: "r01",
    site: "条漫星球",
    title: "新作《星之契约》全篇上线",
    tag: "奇幻",
    today: "今天 11:05",
    badge: "新作",
  },
  {
    id: "r02",
    site: "追更社",
    title: "榜单速报：本周人气 Top 10 出炉",
    tag: "榜单",
    today: "今天 08:40",
    badge: "速报",
  },
  {
    id: "r03",
    site: "韩漫屋",
    title: "热门恋爱连载恢复日更",
    tag: "恋爱",
    today: "今天 09:20",
    badge: "更新",
  },
  {
    id: "r04",
    site: "漫小馆",
    title: "暑期新番盘点：二十部必看推荐",
    tag: "盘点",
    today: "昨天 22:15",
    badge: "推荐",
  },
  {
    id: "r05",
    site: "韩漫图鉴",
    title: "悬疑佳作《迷局档案》完结补番指南",
    tag: "悬疑",
    today: "昨天 20:30",
    badge: "完结",
  },
];

export const guideSteps: GuideStep[] = [
  {
    id: "g1",
    num: "01",
    title: "收藏本页",
    desc: "把本站加入浏览器收藏夹，或使用「收藏本站」按钮，随时一键回到导航首页。",
  },
  {
    id: "g2",
    num: "02",
    title: "挑选入口",
    desc: "根据题材分类或搜索关键词，快速定位你想看的韩漫站点与对应阅读页。",
  },
  {
    id: "g3",
    num: "03",
    title: "进入阅读",
    desc: "点击直达按钮进入站点，站内均提供清晰剧集列表，方便继续上次阅读。",
  },
  {
    id: "g4",
    num: "04",
    title: "开启追更",
    desc: "留意各站更新提醒与本站最新发布页，第一时间获取连载新章与新作动态。",
  },
];

export const faqItems: FaqItem[] = [
  {
    id: "f1",
    q: "这个网站是做什么的？",
    a: "本站是一个韩漫网址导航聚合页，把分散的热门韩漫站点入口、分类频道与最新发布页整理到同一个页面，帮助你快速找到想看的韩漫地址，省去反复搜索的麻烦。",
  },
  {
    id: "f2",
    q: "收藏本站有什么用？",
    a: "把本站加入收藏后，下次想追更韩漫时直接打开导航即可，无需再逐个站点搜索入口。导航会持续整理并更新最新发布页，追更更方便。",
  },
  {
    id: "f3",
    q: "为什么有些入口会失效？",
    a: "部分站点可能因网络或维护出现入口变动，本站会及时整理可用入口与最新发布页。如果发现某个入口失效，欢迎通过「提交收录」反馈，我们会尽快补充更新。",
  },
  {
    id: "f4",
    q: "导航里的站点分类有哪些？",
    a: "本站按题材分为动作热血、恋爱校园、奇幻异世界、悬疑惊悚、搞笑日常、都市职场等大类，每个分类下都整理了对应的韩漫站点入口，方便你按口味挑选。",
  },
  {
    id: "f5",
    q: "如何找到最新发布的韩漫？",
    a: "首页「最新发布页」板块会持续更新各站点的新作上线、榜单速报与完结补番信息，直接查看该板块即可快速掌握最近可看的韩漫动态。",
  },
  {
    id: "f6",
    q: "可以提交或推荐新的韩漫站点吗？",
    a: "当然可以。通过页面的「提交收录」表单填写站点名称、地址与题材分类即可，我们审核整理后会把它加入对应的导航分类中。",
  },
];

export const popularKeywords = [
  "动作热血",
  "恋爱校园",
  "奇幻异世界",
  "悬疑惊悚",
  "搞笑日常",
  "都市职场",
  "新作首发",
  "完结补番",
];